import { create } from 'zustand';
import type { User } from '@shared/types/user.types';

interface AuthState {
  user: User | null;
  isLoading: boolean;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  isLoading: true,

  fetchUser: async () => {
    try {
      const res = await fetch('/api/auth/me', { credentials: 'include' });
      if (!res.ok) throw new Error('Auth check failed');
      const json = await res.json();
      set({ user: json.data || null, isLoading: false });
      window.__authState = { resolved: true, user: json.data || null };
    } catch {
      set({ user: null, isLoading: false });
      window.__authState = { resolved: true, user: null };
    }
  },

  logout: async () => {
    try { await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' }); } catch {}
    set({ user: null, isLoading: false });
    window.__authState = { resolved: true, user: null };
  },
}));
